<template>
    <div class="lang">
        <span v-for="(lang, index) in languageList" :key="lang.name" @click="changeLanguage(lang.name)"
        :class="{'active': languageIndex == index}"
        >
          {{lang.val}}
        </span>
    </div>
</template>

<script>
import { setup } from "../../../locales"
export default {
    name: 'ztHeader',
    computed: {
        language: {
            get() {
                return this.languageList[this.languageIndex].val;
            },
            set() {
                return this.languageList[this.languageIndex].val;
            }
        }
    },
    data: function () {
        return {
            languageIndex: 0,
            languageList: [
                {
                name: "cn",
                val: "中文"
                },
                {
                name: "en",
                val: "English"
                },
                {
                name: "es",
                val: "Español"
                },
                {
                name: "fr",
                val: "Français"
                },
                {
                name: "ru",
                val: "Русский"
                }
            ],
        }
    },
    methods: {
        // 切换语言
        changeLanguage(language) {
          for (let index = 0; index < this.languageList.length; index++) {
            const element = this.languageList[index];
            if(language == element.name) {
              this.languageIndex = index
              setup(language)
            }
            
          }
          
        },
        setDefaultLanguage() {
        let currentLanguage = window.localStorage.getItem("localeLanguage")
            for (let i = 0; i < this.languageList.length; i++) {
              if (currentLanguage == this.languageList[i].name) {
                this.language = this.languageList[i].val;
                this.languageIndex = i
              }
            }
        },
    },
    created () {
        this.setDefaultLanguage()
    },
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped lang="scss">
.lang {
  display: inline-block;
  span {
    margin-right: 10px;
    cursor: pointer;
    &.active {
      font-weight: bold;
    }
  }
}
</style>
